const id_master_sales = {
    "": "sales",
    add: 'tambah sales',
    edit: 'ubah sales',

    label: {
        coa: "Kode COA Hutang Komisi",
    },

    error: {
        create: 'Gagal membuat sales',
        edit: 'Gagal mengubah sales',
        delete: 'Gagal menghapus sales',
        user: "Pengguna tidak boleh kosong.",
    },

    success: {
        create: 'Berhasil membuat sales',
        edit: 'Berhasil mengubah sales',
        delete: 'Berhasil menghapus sales',
    },
}

export default id_master_sales;